"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _Slider = _interopRequireDefault(require("@material-ui/core/Slider"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    flexGrow: 1,
    margin: theme.spacing(2)
  }
}));

const MediaVolumeSlider = ({
  className,
  min = 0,
  max = 1,
  value = 0,
  onChange
}) => {
  const classes = useStyles();

  const handleChange = (event, value) => {
    onChange && onChange(value);
  };

  return _react.default.createElement(_Slider.default, {
    className: className || classes.volume,
    step: .1,
    marks: true,
    min: min,
    max: max,
    value: value,
    onChange: handleChange
  });
};

var _default = MediaVolumeSlider;
exports.default = _default;
module.exports = exports.default;